import { API } from "../auth/authApi";

export const getContentCategoriesApi = () => {
  return API.get("/content/category");
};

export const createContentCategoryApi = (data) => {
  const formData = new FormData();

  formData.append("title", data.title);
  formData.append("description", data.description || "");
  formData.append("file", data.file);

  return API.post("/content/category", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const updateContentCategoryApi = (categoryId, data) => {
  const formData = new FormData();

  formData.append("title", data.title);
  formData.append("description", data.description || "");

  if (data.file) {
    formData.append("file", data.file);
  }

  return API.put(`/content/category/${categoryId}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const createContentSubCategoryApi = (data) => {
  return API.post("/content/subcategory", data);
};

export const deleteContentCategoryApi = (categoryId) => {
  return API.delete(`/content/category/${categoryId}`);
};

export const deleteContentSubCategoryApi = (subCategoryId) => {
  return API.delete(`/content/subcategory/${subCategoryId}`);
};

export const getPostsApi = (params) => {
  return API.get("/post", { params });
};

export const createPostApi = (data) => {
  const formData = new FormData();

  formData.append("categoryId", data.categoryId);
  formData.append("subCategoryId", data.subCategoryId);
  formData.append("title", data.title);
  formData.append("description", data.description);
  formData.append("isFeatured", data.isFeatured);
  formData.append("link", data.link);
  formData.append("file", data.file);

  return API.post("/post", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const updatePostApi = (postId, data) => {
  const formData = new FormData();

  formData.append("categoryId", data.categoryId);
  formData.append("subCategoryId", data.subCategoryId);
  formData.append("title", data.title);
  formData.append("description", data.description);
  formData.append("isFeatured", data.isFeatured);
  formData.append("link", data.link);

  if (data.file) {
    formData.append("file", data.file);
  }

  return API.put(`/post/${postId}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const deletePostApi = (postId) => {
  return API.delete(`/post/${postId}`);
};
